<!-- Card Header -->
<div class="card-header">
  <!--<label>{{ pageTitle }}</label>-->

  <label>{{ pageTitle | translate}}</label>

  <!-- Header actions -->
  <span class="actions">

    <div class="zoom" *ngIf="homeService.dataZoom">
      <button type="button" class="btn" (click)="homeService.zoomOut()">-</button>
      <span>{{homeService.currentZoomLevel}}%</span>
      <button type="button" class="btn" (click)="homeService.zoomIn()">+</button>
    </div>

    <ng-container *ngIf="languageSelectDropDown">
      <label for="language-select" translate>Language</label>
      <select name="language-select" (change)="switchLang($event.target.value)">
        <option *ngFor="let language of languages" value="{{language.languageCode}}" [selected]="language.languageCode===translateService.currentLang">{{language.languageName | translate}}</option>
    </select>
    </ng-container>

    <ng-container *ngIf="homeService.dataFilterButton">
      <button id="dataFilter" type="button" class="btn" (click)="dataFilter()" data-toggle="modal" data-target="#exampleModal" translate><span *ngIf="dataFilterIcon">√</span>Data Filter</button>
    </ng-container>

    <ng-container *ngIf="homeService.exportExcel || homeService.exportImage">
      <button type="button" class="btn" (click)="export();" translate>Export</button>
    </ng-container>

    <button type="button" class="btn" (click) = "redirectToHome();" translate>Home</button>

    <ng-container *ngIf="!isFullScreen">
      <button type="button" class="btn" (click)="openFullscreen()">
        <i class="fa fa-window-maximize"></i>
      </button>
    </ng-container>
    <ng-container *ngIf="isFullScreen">
      <button type="button" class="btn" (click)="closeFullscreen()">
        <i class="fa fa-window-minimize"></i>
      </button>
    </ng-container>
  </span>

</div>

<ng-container *ngIf="dataFilterVisibility">
  <app-data-filters [dataFilterInput]="dataFilterObj"></app-data-filters>
</ng-container>